import { z } from 'zod';

// `rescources` mirrors the upstream Trustpilot view payload's misspelling — do not "fix" it.
export const schemaTrustpilotProfileResponse = z.object({
    profile: z.object({
        count: z.number().int().nonnegative(),
        score: z.number().min(0).max(5),
        stars: z.number().int().min(0).max(5),
        ts: z.number().int().nonnegative(),
    }),
    rescources: z.object({
        logoDarkUrl: z.string(),
        logoLightUrl: z.string(),
        starsUrl: z.string(),
    }),
});

export type SchemaTrustpilotProfileResponse = z.infer<typeof schemaTrustpilotProfileResponse>;
